import MicroModal from 'micromodal'
import React from 'react'
import Button from '../../../common/button/Button'
import ResponseMessage from '../../../common/modal/ResponseMessage'
import Modal from '../../../common/modal/Modal'
import { useGroupDashboardContext } from '../GroupDashboardContext'

const CheckoutModal = ({ modalId, responseMessage }) => {

  const { selectedSeats } = useGroupDashboardContext()

  return (
    <Modal 
        modalId={modalId} 
        buttonTitle=""
        modalHeading={"Add seats"}
        modalClassNames={'msync-members-custom-modal'}
      >
      <main className="msync-modal__body">
        { responseMessage && <ResponseMessage response={ responseMessage } /> }
        {
          selectedSeats &&
          <p>
            This action will <strong>{ selectedSeats.totalSeats >= selectedSeats.seatCount ? 'add' : 'remove' } { `${selectedSeats.seatToAdd} ${selectedSeats.seatText}` } </strong>, resulting in a total of <strong>{ `${selectedSeats.totalSeats} ${selectedSeats.totalSeatsText}` }.</strong><br/>
            When you click confirm you'll be redirected to checkout to purchase your additional seats.
          </p>
        }
      </main>
      <footer className="msync-modal__footer">
        <Button
          className="msync-button--is-style-outline msync-button--is-theme-destructive"
          type="button"
          data-micromodal-close
          aria-label="Close this dialog window"
        >
          Cancel
        </Button>
        <a
          type='button'
          href={ selectedSeats.checkoutURL ?? '#' } 
          className="msync-btn msync-primary-btn-anchor"
        >
          Confirm
        </a>
      </footer>
    </Modal>
  )
}

export default CheckoutModal
